import Swiper from 'swiper';
import { refs, domReady, booleanDataset } from '../modules/utils.js';
import { Autoplay } from 'swiper/modules';

class FullSlider extends HTMLElement {
  static get observedAttributes() {
    return ['data-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-index') {
      booleanDataset(this.refs.progress, 'active', false);
      setTimeout(() => booleanDataset(this.refs.progress, 'active', true), 10);
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
    this.#slider();
  }

  #listeners() { }

  #slider() {
    if (!this.refs.slider) return;
    if (this.refs.slides?.length < 2) {
      this.refs.slides[0].classList.add('swiper-slide-active');
      booleanDataset(this.refs.progress, 'active', false);
      return;
    };

    this.slider = new Swiper(
      this.refs.slider,
      {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        modules: [Autoplay],
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        }
      }
    );

    this.slider.on('slideChange', () => {
      this.dataset.index = this.slider.realIndex;
    });
  }
}

customElements.define('full-slider', FullSlider);
